import axios from "axios"
import { NowInDateTimeFormat } from "../Components/GeneralFunctions"

const cPushBaseApi = "https://push-va.cloudcti.nl/pushbeta/" 

export async function PushApiRegisterUserAsWebclientUser(aSecurityToken)
{
    try 
    {
        await axios.post(cPushBaseApi + "/webclient/register",  
        {
        },
        {
            headers: {
                Authorization: "Bearer " + aSecurityToken,
                Accept: "application/json"
            }
        }) 
    } 
    catch (ex)
    { 
        console.log("Failed to register user as webclient user")
        console.log(ex)
    }   
}

export async function PushApiAddBrowserNotification(aSecurityToken, aBrandNotificationLogo, aEndPoint, aP256dh, aAuth, aResponseNotification)
{
    return axios.post(cPushBaseApi + "browsernotification",  
    {
        Endpoint: aEndPoint,
        P256dh: aP256dh,
        Auth: aAuth,
        BrandNotificationLogo: aBrandNotificationLogo,
        TestNotification: aResponseNotification
    },
    {
        headers: {
            Authorization: "Bearer " + aSecurityToken,
            Accept: "application/json",
            ContentType: "application/json"
        }
    })    
}

export async function PushApiDeleteBrowserNotification(aSecurityToken, aEndPoint, aP256dh, aAuth)
{
    return axios.delete(cPushBaseApi + "browsernotification?endpoint=" + encodeURIComponent(aEndPoint) + "&p256dh=" + encodeURIComponent(aP256dh) + "&auth=" + encodeURIComponent(aAuth),  
    {
        headers: {
            Authorization: "Bearer " + aSecurityToken,
            Accept: "application/json"
        }
    })    
}

export async function PushApiGetBrowserNotificationSetting(aSecurityToken)
{
    return axios.get(cPushBaseApi + "browsernotification/setting",  
    {
        headers: {
            Authorization: "Bearer " + aSecurityToken,
            Accept: "application/json"
        }
    })    
}

export async function PushApiSetBrowserNotificationSetting(aSecurityToken, aEnabled)
{
    return axios.put(cPushBaseApi + "browsernotification/setting?enabled=" + (aEnabled ? "True" : "False"),  
        {

        },
        {
            headers: {
                Authorization: "Bearer " + aSecurityToken,
                Accept: "application/json",
                ContentType: "application/json"
            }
        })     
}

/*
export async function PushApiSubscribe(aSecurityToken, aBrandNotificationLogo, aEndPoint, aP256dh, aAuth)
{

    return axios.post(cPushBaseApi + "push/settings",  
    {
        Settings: {
            Endpoint: aEndPoint,
            P256dh: aP256dh,
            Auth: aAuth,
        },
        BrandNotificationLogo: aBrandNotificationLogo,
        TestNotification: "Browser notifications activated"
    },
    {
        headers: {
            Authorization: "Bearer " + aSecurityToken,
            Accept: "application/json"
        }
    })    
}

export async function PushApiUnsubscribe(aSecurityToken) 
{
    return axios.delete(cPushBaseApi + "push/settings",  
    {
        headers: {
            Authorization: "Bearer " + aSecurityToken,
            Accept: "application/json"
        }
    })     
}

export async function PushApiHasSubscription(aSecurityToken) 
{
    return axios.get(cPushBaseApi + "push/settings",  
    {
        headers: {
            Authorization: "Bearer " + aSecurityToken,
            Accept: "application/json"
        }
    })     
}
*/

export async function PushApiGetCallHistory(aSecurityToken) 
{
    try
    {
        const result = await axios.get(cPushBaseApi + "callhistory",  
        {
            headers: {
                Authorization: "Bearer " + aSecurityToken,
                Accept: "application/json"
            }
        })     
        return result.data
    } 
    catch (ex)
    { 
        return "" 
    }
} 

export async function PushApiCallHistoryAddOutboundCall(aSecurityToken, aCallId, aNumber, aName, aApplication, aScripts) 
{
    try 
    {
      await axios.post(
        cPushBaseApi + "callhistory/call",
        {
            DateTime:NowInDateTimeFormat(),
            Incoming:false,
            Duration:"",
            Number:aNumber,
            Name: aName !== null ? aName : "",
            Application: aApplication !== null ? aApplication : "", 
            Scripts: aScripts !== null ? aScripts : [],
            CallId: aCallId
        },
        {
            headers: {
                Authorization: "Bearer " + aSecurityToken,
                Accept: "application/json",
                ContentType: "application/json"
            }
        })
    } 
    catch (ex)
    { 
    }
}

export async function PushApiCallHistoryDeleteCall(aSecurityToken, aCallId) 
{
    try 
    {
        await axios.delete(
            cPushBaseApi + "callhistory/call?callid=" + aCallId,
            {
                headers: {
                    Authorization: "Bearer " + aSecurityToken,
                    Accept: "application/json",
                    ContentType: "application/json"
                }
            }
        )
    } 
    catch (ex)
    { 
        console.log("PushApiCallHistoryDeleteCall failed")
        console.log(ex)
    }
}

